module.exports = __webpack_public_path__ + "img/0-95.b123af6a.jpg";